import { createFileRoute } from '@tanstack/react-router';
import { APP_PATHS, PAGE_PATHS, Permission } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/detections/rules/create/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({
      path: PAGE_PATHS.RULES,
      app: APP_PATHS.DETECTIONS,
      permission: Permission.CREATE,
    });
    context.validatePermissions({ isAllowed, preload });
  },
});
